import styles from './FJHeader.module.less';
import PropTypes from 'prop-types';

const FJHeader = props => {
    const { title, children } = props;
    return (
        <div className={styles.box}>
            <div className={styles.title}>{title}</div>
            {children}
        </div>
    );
};

FJHeader.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
};
export default FJHeader;
